import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';

export default {
    init() {
        Vue.use(Vue2TouchEvents);
    },
};
